const baseURL = [ 'localhost', '127.0.0.1' ].includes(window.location.hostname)
  ? 'http://127.0.0.1:3001/api/main/'
  : window.location.origin + '/api/main/';

export default baseURL;
